import styled from "styled-components";

interface IDivAlignCenterWithOverflow{
    mediaQueryMaxWidth?: boolean;
    directionColumn?: boolean;
}

export const DivAlignCenterWithOverflow = styled.div<IDivAlignCenterWithOverflow>`
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
    ${(props) => props.directionColumn && `
        flex-direction: column; 
    `}
    ${(props) => props.mediaQueryMaxWidth && `
        @media(max-width: 1322px){
            max-width: 228px;
        }
    `}
`;

interface IsBold{
    bold?: boolean;
    red?: boolean;
    green?: boolean;
    purple?: boolean;
}

export const OverflowSpan = styled.span<IsBold>`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    
    ${(props) => props.bold ? "font-weight: bold;" : ""}
    ${(props) => props.red ? "color: var(--red);" : ""}
    ${(props) => props.green ? "color: var(--green);" : ""}
    ${(props) => props.purple ? "color: var(--purple-lighter);" : ""}
`;

interface IDivValues{
    borderRight?: boolean;
    borderLeft?: boolean;
}

export const DivValues = styled.div<IDivValues>`
    display: flex;
    align-items: center;
    width: 100%;
    overflow-x: hidden; 
    overflow-y: hidden; 
    position: relative;

    transition: 200ms ease;

    ${(props) => props.borderRight && `
        border-right: 2px solid var(--border-color);
    `}
    ${(props) => props.borderLeft && `
        border-left: 2px solid var(--border-color);
    `}
`;

export const TD = styled.div<IDivValues>`
    width: 96px;
    min-width: 96px;
    max-width: 96px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
    padding: 4px 2px;

    position: relative;

	color: var(--default-color-font);

    &.value-predicted{
        background: var(--jexcel-header-footer);
    }
    &.value-realized{
        background:  var(--li-child-color);
    }
    &.value-variation-value{
        background: var(--jexcel-row-not-striped);
    }
    &.value-variation-percent{
        background: var(--li-header-color);
    }

    >span{
        z-index: 1;
    }

    ${(props) => props.borderRight && `
        border-right: 2px solid var(--border-color);
    `}
    ${(props) => props.borderLeft && `
        border-left: 2px solid var(--border-color);
    `}
`;


export const DivColumn = styled.div`
    display: flex; 
    flex-direction: column; 
    align-items: flex-end;
    small{
        font-size: 0.65rem;
    }
`;

export const StyledDivIconIndicatorChart = styled.div`
    display: flex;
    align-items: center;
    width: 1rem;
    cursor: pointer;
    transition: 100ms ease;
`;

export const DivFlex = styled.div`
    display: flex;
    transition: 300ms ease;
`;

export const Line = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0.2rem;
    font-size: 0.9rem;

    color: var(--input-font-color);
`;


export const ListStyles = `
    min-width: 1192px;
    >li.list-component-header{
        margin: 0;
        padding: 0;
        border-bottom: 2px solid var(--border-color);
    }
    >li.list-component-child{
        padding: 0;
    }
    @media(max-width: 600px){
        >li{
            flex-direction: row !important;
        }
    }
`;
